// src/store/slices/settingsSlice.js
import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import settingsApi from "api/settingsApi"; // Fixed import

export const fetchSettings = createAsyncThunk(
  "settings/fetchSettings",
  async (_, { rejectWithValue }) => {
    try {
      const data = await settingsApi.getSettings();
      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.detail || "Failed to load settings"
      );
    }
  }
);

export const updateSettings = createAsyncThunk(
  "settings/updateSettings",
  async (data, { rejectWithValue }) => {
    try {
      const response = await settingsApi.updateSettings(data);
      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { can_accept_orders: ["Update failed"] }
      );
    }
  }
);

export const setCanteenSettings = createAction("settings/setCanteenSettings");

const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    can_accept_orders: true,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettings.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.can_accept_orders = action.payload.can_accept_orders ?? true;
      })
      .addCase(fetchSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateSettings.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateSettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.can_accept_orders = action.payload.can_accept_orders;
      })
      .addCase(updateSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(setCanteenSettings, (state, action) => {
        state.can_accept_orders = action.payload.can_accept_orders;
      });
  },
});

export const { clearError } = settingsSlice.actions;
export default settingsSlice.reducer;
